import React from "react";
import { GatsbyImage as Image, getImage } from "gatsby-plugin-image";
import { graphql } from "gatsby";

export default function FullWidthImage({ data }) {
  return (
    <section className="bg-white w-full">
      <div className="w-full right-0 inset-y-0 overflow-hidden h-96">
        <Image
          className="w-full h-full object-cover object-center"
          image={getImage(data.image)}
          alt={data.image.alt}
        />
      </div>
    </section>
  );
}

export const query = graphql`
  fragment FullWidthImageComponent on DatoCmsFullWidthImage {
    internal {
      type
    }
    id
    image {
      alt
      gatsbyImageData
      url
    }
  }
`;
